import home from '@/router/medical/home'
import medical from '@/router/medical/medicalMange'
import patient from '@/router/medical/medicalPatient'
import staffMangement from '@/router/medical/medicalStaff'
import medicaldataCenter from '@/router/medical/medicaldataCenter'
import setting from '@/router/medical/setting'

const routes = [
  ...home,//工作台
  ...medical,//预约
  ...patient,//患者
  ...staffMangement,//员工管理
  ...medicaldataCenter,//医疗数据中心
  ...setting,//设置
]
export default routes;
